import SearchByTag from 'components/pages/Article/SearchByTag'
import MetaTags from 'components/pages/Article/SearchByTag/MetaTags'
import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import NoindexRemoval from 'components/common/NoindexRemoval'
import { getKeywordByUrlId, getArticles, getArticleCount } from 'utils/api'

const SearchByTagPage = (props) => {
  return (
    <>
      <NoindexRemoval />
      <MetaTags
        resolvedUrl={props.resolvedUrl}
        keyword={props.fallbackData?.keyword}
      />
      <SearchByTag {...props} />
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const tagUrlId = context.params?.tagUrlId
  const { res } = context
  const [keyword, keywordError] = await getKeywordByUrlId(tagUrlId)
  if (keywordError) {
    // API 失敗 ≠ tag 不存在：不可把停機變成被快取的永久轉址，
    // 丟給 withSafeServerSideProps 分流（審核器 302 首頁、一般人 500）
    throw keywordError
  }
  if (!keyword) {
    res.setHeader('Cache-Control', 'max-age=300')
    return {
      redirect: {
        destination: `/article`,
        permanent: true,
      },
    }
  }
  const [articlesResult, articleCountResult] = await Promise.all([
    getArticles({ keywordId: keyword?._id, limit: 20 }),
    getArticleCount({ keywordId: keyword?._id }),
  ])
  const [articles, error] = articlesResult || []
  const [articleCount, countError] = articleCountResult || []

  if (error || countError) {
    const logger = require('utils/server-utils/logger')
    logger.warn({
      event: 'gssp_fetch_error_degraded',
      page: context.resolvedUrl,
      reason: (error || countError)?.message,
    })
  }

  return {
    props: {
      fallbackData: {
        keyword,
        articles: articles ?? [],
        articleCount: articleCount ?? 0,
      },
      resolvedUrl: context.resolvedUrl,
    },
  }
})

export default withLivingSinyi(SearchByTagPage)
